export function getEnv(origin) {
  let thisEnv = 'production'
  if (origin.indexOf('http://localhost') !== -1 || origin.indexOf('http://10.1.11') !== -1) {
    thisEnv = 'qa'
  } else if (origin.indexOf('https://dev-configure') !== -1) {
    thisEnv = 'development'
  } else if (origin.indexOf('https://qa-configure') !== -1) {
    thisEnv = 'qa'
  } else if (origin.indexOf('https://uat-configure') !== -1) {
    thisEnv = 'uat'
  }
  return thisEnv
}

export function getOrigin(windowObj) {
  // for IE - set window.location.origin if browser does not have window.location.origin
  if (!windowObj.location.origin) {
    windowObj.location.origin = `${windowObj.location.protocol}//${windowObj.location.hostname}${
      windowObj.location.port ? ':' + windowObj.location.port : ''
    }`
  }
  return windowObj.location.origin
}

const nodeENV = getEnv(getOrigin(window))

const envConfig = {
  development: {
    apiURL: 'https://dev-api.trdev.co/',
    cas: {
      login: 'https://dev-login.trdev.co/login?',
      logout: 'https://dev-manage.trdev.co/manage/sign-out.cfm'
    },
    heimdallUrl: 'service=https://dev-api.trdev.co/auth/configure-ui',
    manageUrl: 'https://dev-manage.trdev.co/manage',
    imagesURL: 'https://dev-images.trdev.co'
  },
  qa: {
    apiURL: 'https://qa-api.jobappdemo.com/',
    cas: {
      login: 'https://qa-login.jobappdemo.com/login?',
      logout: 'https://qa-manage.jobappdemo.com/manage/sign-out.cfm'
    },
    heimdallUrl: 'service=https://qa-api.jobappdemo.com/auth/configure-ui',
    manageUrl: 'https://qa-manage.jobappdemo.com/manage',
    imagesURL: 'https://qa-images.jobappdemo.com'
  },
  uat: {
    apiURL: 'https://uat-api.jobappdemo.com/',
    cas: {
      login: 'https://uat-login.jobappdemo.com/login?',
      logout: 'https://uat-manage.jobappdemo.com/manage/sign-out.cfm'
    },
    heimdallUrl: 'service=https://uat-api.jobappdemo.com/auth/configure-ui',
    manageUrl: 'https://uat-manage.jobappdemo.com/manage',
    imagesURL: 'https://uat-images.jobappdemo.com'
  },
  production: {
    apiURL: 'https://api.jobappnetwork.com/',
    cas: {
      login: 'https://login.jobappnetwork.com/login?',
      logout: 'https://secure.jobappnetwork.com/manage/sign-out.cfm'
    },
    heimdallUrl: 'service=https://api.jobappnetwork.com/auth/configure-ui',
    manageUrl: 'https://secure.jobappnetwork.com/manage',
    imagesURL: 'https://images.jobappnetwork.com'
  }
}

const apiURL = envConfig[nodeENV].apiURL

const endPoints = {
  base: apiURL,
  clients: `${apiURL}clients`,
  v1: `${apiURL}v1/clients`,
  v2: `${apiURL}v2/clients`
}

const casLogoutUrl = envConfig[nodeENV].cas.logout

const casLoginUrl = envConfig[nodeENV].cas.login
const heimdallUrl = envConfig[nodeENV].heimdallUrl
const manageUrl = envConfig[nodeENV].manageUrl
const imagesURL = envConfig[nodeENV].imagesURL
const version = process.env.REACT_APP_VERSION

const baseUrl = ''

const headers = {
  accept: 'application/json',
  'Content-Type': 'application/json',
  'cache-control': 'no-store',
  pragma: 'no-cache'
}

const fetchOptions = (version) => {
  const versionOptions = ['v1', 'v2']
  if (typeof version !== 'string' || !versionOptions.includes(version))
    throw new Error('must be a string: v1 or v2')
  return {
    credentials: 'include',
    withCredentials: 'true',
    headers: {
      ...headers,
      'x-api': `forms_${version}`
    }
  }
}

const envAliasesMap = {
  development: 'dev',
  qa: 'qa',
  uat: 'uat',
  production: 'prod'
}

const envAlias = envAliasesMap[nodeENV]

export {
  casLogoutUrl,
  casLoginUrl,
  endPoints,
  manageUrl,
  heimdallUrl,
  version,
  baseUrl,
  imagesURL,
  fetchOptions,
  envAlias
}



// WEBPACK FOOTER //
// ./src/config/endpoints.js